// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationInvitationId: z.string().min(1).max(21),
    organizationManagementRoleId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationInvitationId: z.string().min(1).max(21),
    organizationManagementRoleId: z.string().min(1).max(21),
});
export const OrganizationInvitationManagementRoleRelations = Object.freeze({
    table: 'organization_invitation_management_role_relations',
    tableSingular: 'organization_invitation_management_role_relation',
    fields: {
        tenantId: 'tenant_id',
        organizationInvitationId: 'organization_invitation_id',
        organizationManagementRoleId: 'organization_management_role_id',
    },
    fieldKeys: [
        'tenantId',
        'organizationInvitationId',
        'organizationManagementRoleId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
